import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import StateTranslate from "../../Components/StateTranslate";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListServices(props) {
  const apiToken = useContext(TokenContext);
  const [announcementsListTemp, setAnnouncementsListTemp] = useState();
  const [announcementsList, setAnnouncementsList] = useState();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [loading, setLoading] = useState(true);

  let query = useQuery();

  useEffect(() => {
    if (apiToken) {
      if (query.get("id")) {
        setLoading(false);
        Repo.getAnnouncementsByService(apiToken, query.get("id"))
          .then((response) => {
            setAnnouncementsListTemp(
              response.data.filter((a) => a.state === "OPEN")
            );
            setLoading(true);
          })
          .catch((error) => {
            setLoading(true);
            console.log(error);
          });
      }
    }
  }, []);

  return (
    <div>
      <h1>Bandi</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Tutti i bandi aperti</p>
      </div>

      <div className="row">
        {announcementsList && announcementsList.length > 0 ? (
          announcementsList
            .filter((a) => a.state === "OPEN")
            .map((x, index) => (
              <div key={x.id} className="col-12 col-lg-4">
                <Link
                  to={"/intervento_categoria/visualizza_categoria?id=" + x.id}
                  className="text-decoration-none"
                >
                  <div className="card-wrapper card-space cardCustom">
                    <div className="card card-bg no-after roundedCustom p-2 ">
                      <div className="card-body">
                        <h5 style={{ fontSize: "23px" }} className="card-title">
                          {x.name}
                        </h5>
                        <div className="row">
                          <div className="col-12">
                            <p
                              style={{ fontSize: "20px" }}
                              className="card-text"
                            >
                              Intervento: <strong>{x.service.name}</strong>
                            </p>
                          </div>
                          {x.subscriptions.length > 0 &&
                          x.subscriptions[0].state == "VALIDATED" ? (
                            <div className="col-12 mt-2">
                              <svg className="icon icon-success mr-2 mb-1">
                                <use
                                  xlinkHref={`${iconSprite}#it-check-circle`}
                                ></use>
                              </svg>
                              <b className="text-success">
                                {"Richiesta accettata".toUpperCase()}
                              </b>
                            </div>
                          ) : x.subscriptions.length > 0 &&
                            x.subscriptions[0].state == "REFUSED" ? (
                            <div className="col-12 mt-2">
                              <svg className="icon icon-danger mr-2 mb-1">
                                <use
                                  xlinkHref={`${iconSprite}#it-close-circle`}
                                ></use>
                              </svg>
                              <b className="text-danger">
                                {"Richiesta rifiutata".toUpperCase()}
                              </b>
                            </div>
                          ) : x.subscriptions.length > 0 &&
                            x.subscriptions[0].state == "ADDED" ? (
                            <div className="col-12 mt-2">
                              <svg className="icon icon-warning mr-2 mb-1">
                                <use
                                  xlinkHref={`${iconSprite}#it-warning-circle`}
                                ></use>
                              </svg>
                              <b className="text-warning">
                                {"Richiesta inviata".toUpperCase()}
                              </b>
                            </div>
                          ) : x.subscriptions.length > 0 &&
                          x.subscriptions[0].state == "PAGAMENTO" ? (
                          <div className="col-12 mt-2">
                             <svg className="icon icon-success mr-2 mb-1">
                                <use
                                  xlinkHref={`${iconSprite}#it-check-circle`}
                                ></use>
                              </svg>
                            <b className="text-warning">
                              {"Richiesta accettata".toUpperCase()}
                            </b>
                          </div>
                        ) : (
                            <div className="col-12 mt-2">
                              <strong className="text text-dark">
                                NON SEI ISCRITTO
                              </strong>
                            </div>
                          )}
                          <b>
                            <StateTranslate text={x.state} trasform="U" />
                          </b>
                          <div className="col-12 text-right mt-4">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                            >
                              <span>Dettaglio</span>
                              <span>
                                <svg className="icon icon-primary icon-sm">
                                  <use href={`${iconSprite}#it-arrow-right`} />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))
        ) : (
          <div>
            <h3>Non ci sono interventi aperti per questo categoria!</h3>
          </div>
        )}
        {announcementsListTemp && (
          <Pagination
            items={announcementsListTemp}
            setCurrentItems={setAnnouncementsList}
            itemsPerPage={6}
          ></Pagination>
        )}
      </div>
      {/* <hr></hr>
      <div className="row">
        <h4>Servizi Conclusi</h4>
      </div> */}
      {!loading && <Loader></Loader>}
    </div>
  );
}

export default ListServices;
